"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareDiscreteInitialValues = exports.discreteEditFilter = exports.discreteCreateFilter = void 0;
const exchange_1 = require("@framework/exchange");
const discreteCreateFilter = ({ contractId, attribute, discreteStrategy, growthRate, price }) => ({
    contractId,
    attribute,
    discreteStrategy,
    growthRate,
    price: (0, exchange_1.cleanUpAsset)(price),
});
exports.discreteCreateFilter = discreteCreateFilter;
const discreteEditFilter = ({ discreteStatus, discreteStrategy, growthRate, price }) => ({
    discreteStatus,
    discreteStrategy,
    growthRate,
    price: (0, exchange_1.cleanUpAsset)(price),
});
exports.discreteEditFilter = discreteEditFilter;
const prepareDiscreteInitialValues = ({ id, contractId, attribute, discreteStatus, discreteStrategy, growthRate, price, }) => {
    return {
        id,
        contractId,
        attribute,
        discreteStatus,
        discreteStrategy,
        growthRate,
        price,
    };
};
exports.prepareDiscreteInitialValues = prepareDiscreteInitialValues;
//# sourceMappingURL=schemas.js.map